import { queryOptions } from '@tanstack/react-query';

import DIContainer from '@lib/dicontainer';
import { PUBLIC_METADATA } from '@lib/types/public-metadata';
import { isPublicMetadataPath } from '@lib/utils/public-metadata-path';

const usecase = DIContainer.getPublicMetadataUseCase();
const PUBLIC_METADATA_KEY = 'public-metadata';

export const publicMetadataOptions = (pathname: string) =>
  queryOptions({
    queryKey: [PUBLIC_METADATA_KEY, pathname],
    queryFn: ({ signal }) => usecase.find(pathname, signal),
    enabled: isPublicMetadataPath(pathname),
    staleTime: PUBLIC_METADATA.CACHE_MS,
    retry: false,
  });
